export interface LorenRole {
    id: number;
    name: string;
    privileges: LorenPrivilegeEntityType[];
    readOnly: boolean;
}

export interface LorenRoleFormViewModel {
    id: number;
    name: string;
    entityPrivileges: RolePrivilege[];
    readonly: boolean;
}

export interface RolePrivilege {
    entity: AppModules;
    access: 'READ' | 'READ_WRITE';
}

export enum AppModules {
    ASSET = 'ASSET',
    ROLE = 'ROLE',
    AUTOMATION_RULES = 'AUTOMATION_RULES',
    GROUPS = 'GROUPS',
    GEOFENCE_ZONES = 'GEOFENCE_ZONES'
}

export enum LorenPrivilegeEntityType {
    READ_ASSET = 'ROLE_READ_ASSET',
    WRITE_ASSET = 'ROLE_WRITE_ASSET',
    READ_USER = 'ROLE_READ_USER',
    READ_AUTOMATION_RULES = 'ROLE_READ_AUTOMATION_PLAN',
    WRITE_AUTOMATION_RULES = 'ROLE_WRITE_AUTOMATION_PLAN',
    READ_GROUPS = 'ROLE_READ_ASSET_GROUP',
    WRITE_GROUPS = 'ROLE_WRITE_ASSET_GROUP',
    READ_GEOFENCE_ZONES = 'ROLE_READ_GEOFENCE_ZONE',
    WRITE_GEOFENCE_ZONES = 'ROLE_WRITE_GEOFENCE_ZONE',
    READ_ROLE = 'ROLE_READ_ROLE',
    WRITE_ROLE = 'ROLE_WRITE_ROLE'
}

export const LorenPrivilegeEntityTypeTranslations = new Map<AppModules, string>([
    [AppModules.ASSET, 'roles.asset_privileges'],
    [AppModules.GEOFENCE_ZONES, 'roles.geofence_zones_privileges'],
    [AppModules.ROLE, 'roles.role_privileges'],
    [AppModules.AUTOMATION_RULES, 'roles.automation_rules_privileges'],
    [AppModules.GROUPS, 'roles.groups_privileges']
]);
